import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a4b546f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12 mb-7" }
const _hoisted_6 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6" }
const _hoisted_7 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_8 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_9 = { class: "text-gray-900 fw-bold" }
const _hoisted_10 = { class: "fw-semibold" }
const _hoisted_11 = { class: "fs-6 text-gray-400" }
const _hoisted_12 = { class: "col-md-6 form-group mb-7" }
const _hoisted_13 = { class: "form-label fw-bold required" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-2-4 flex-column" }
const _hoisted_16 = { class: "text-gray-400 mb-1" }
const _hoisted_17 = { class: "col-md-2-4 flex-column" }
const _hoisted_18 = { class: "text-gray-400 mb-1" }
const _hoisted_19 = { class: "col-md-2-4 flex-column" }
const _hoisted_20 = { class: "text-gray-400 mb-1" }
const _hoisted_21 = { class: "col-md-2-4 flex-column" }
const _hoisted_22 = { class: "text-gray-400 mb-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2-4 flex-column" }, null, -1))
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-body p-9" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6 form-group mb-7" }
const _hoisted_28 = { class: "form-label fw-bold required" }
const _hoisted_29 = { class: "col-md-6 form-group mb-7" }
const _hoisted_30 = { class: "form-label fw-bold required" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "d-flex justify-content-between" }
const _hoisted_33 = { class: "fw-bolder" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6 form-group mb-7" }
const _hoisted_36 = { class: "fw-bold text-muted" }
const _hoisted_37 = { class: "col-md-3 form-group mb-7" }
const _hoisted_38 = { class: "fw-bold text-muted" }
const _hoisted_39 = { class: "col-md-3 form-group mb-7" }
const _hoisted_40 = { class: "fw-bold text-muted" }
const _hoisted_41 = { class: "col-md-6 form-group mb-7" }
const _hoisted_42 = { class: "fw-bold text-muted" }
const _hoisted_43 = { class: "col-md-6 form-group mb-7" }
const _hoisted_44 = { class: "fw-bold text-muted" }
const _hoisted_45 = { class: "col-md-3 form-group mb-7" }
const _hoisted_46 = { class: "fw-bold text-muted" }
const _hoisted_47 = { class: "col-md-3 form-group mb-7" }
const _hoisted_48 = { class: "fw-bold text-muted" }
const _hoisted_49 = { class: "col-md-3 form-group mb-7" }
const _hoisted_50 = { class: "fw-bold text-muted" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "col-md-3 form-group mb-7" }
const _hoisted_53 = { class: "fw-bold text-muted" }
const _hoisted_54 = { class: "col-md-3 form-group mb-7" }
const _hoisted_55 = { class: "fw-bold text-muted" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-7" }, null, -1))
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = { class: "fw-bolder" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-6 form-group mb-7" }
const _hoisted_61 = { class: "fw-bold text-muted" }
const _hoisted_62 = { class: "col-md-3 form-group mb-7" }
const _hoisted_63 = { class: "fw-bold text-muted" }
const _hoisted_64 = { class: "col-md-3 form-group mb-7" }
const _hoisted_65 = { class: "fw-bold text-muted" }
const _hoisted_66 = { class: "col-md-6 form-group mb-7" }
const _hoisted_67 = { class: "fw-bold text-muted" }
const _hoisted_68 = { class: "col-md-6 form-group mb-7" }
const _hoisted_69 = { class: "fw-bold text-muted" }
const _hoisted_70 = { class: "col-md-3 form-group mb-7" }
const _hoisted_71 = { class: "fw-bold text-muted" }
const _hoisted_72 = { class: "col-md-3 form-group mb-7" }
const _hoisted_73 = { class: "fw-bold text-muted" }
const _hoisted_74 = { class: "col-md-3 form-group mb-7" }
const _hoisted_75 = { class: "fw-bold text-muted" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "col-md-3 form-group mb-7" }
const _hoisted_78 = { class: "fw-bold text-muted" }
const _hoisted_79 = { class: "col-md-3 form-group mb-7" }
const _hoisted_80 = { class: "fw-bold text-muted" }
const _hoisted_81 = { class: "card card-flush" }
const _hoisted_82 = { class: "card-header py-5 align-items-center border-bottom" }
const _hoisted_83 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fw-bold" }
const _hoisted_84 = { class: "card-toolbar flex-wrap gap-3 align-items-start" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_87 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_88 = { class: "card-body pt-0" }
const _hoisted_89 = { class: "table-responsive" }
const _hoisted_90 = { class: "table table-row-bordered gy-5 fs-6 mb-0 align-top" }
const _hoisted_91 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_92 = { class: "text-start" }
const _hoisted_93 = { class: "text-start" }
const _hoisted_94 = { class: "text-start" }
const _hoisted_95 = { class: "text-start" }
const _hoisted_96 = { class: "text-end" }
const _hoisted_97 = { class: "text-end" }
const _hoisted_98 = { class: "text-end" }
const _hoisted_99 = { class: "mw-240px fs-7 fw-bold text-break text-start" }
const _hoisted_100 = { class: "svg-icon svg-icon-3 svg-icon-danger align-text-top ms-1" }
const _hoisted_101 = { class: "text-end" }
const _hoisted_102 = { class: "text-end" }
const _hoisted_103 = { class: "mw-240px fs-7 fw-bold text-break text-start" }
const _hoisted_104 = { class: "svg-icon svg-icon-3 svg-icon-danger align-text-top ms-1" }
const _hoisted_105 = { class: "text-end" }
const _hoisted_106 = { class: "mw-240px fs-7 fw-bold text-break text-start" }
const _hoisted_107 = { class: "svg-icon svg-icon-3 svg-icon-danger align-text-top ms-1" }
const _hoisted_108 = {
  key: 0,
  class: "text-end"
}
const _hoisted_109 = { class: "fw-bold text-gray-800" }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { class: "text-start" }
const _hoisted_112 = { class: "text-start" }
const _hoisted_113 = { class: "d-flex flex-column" }
const _hoisted_114 = { class: "d-flex align-items-center gap-2" }
const _hoisted_115 = {
  key: 0,
  src: "media/svg/custom/embargoes.svg"
}
const _hoisted_116 = {
  key: 1,
  class: "badge badge-danger text-uppercase"
}
const _hoisted_117 = { class: "mw-150px fs-7 text-line-clamp-1 text-gray-400" }
const _hoisted_118 = { class: "text-end text-nowrap" }
const _hoisted_119 = { class: "text-end" }
const _hoisted_120 = { class: "text-end" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_123 = { class: "text-end text-nowrap" }
const _hoisted_124 = { class: "text-end text-nowrap" }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_127 = { class: "text-end text-nowrap" }
const _hoisted_128 = { key: 0 }
const _hoisted_129 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_130 = {
  key: 0,
  class: "text-end text-nowrap"
}
const _hoisted_131 = ["title", "onClick"]
const _hoisted_132 = { class: "svg-icon svg-icon-3" }
const _hoisted_133 = ["disabled", "title", "onClick"]
const _hoisted_134 = { class: "svg-icon svg-icon-3" }
const _hoisted_135 = ["colspan"]
const _hoisted_136 = ["colspan"]
const _hoisted_137 = { class: "d-flex flex-column gap-6" }
const _hoisted_138 = { class: "fs-4 fw-bold" }
const _hoisted_139 = { class: "fs-4 fw-bold" }
const _hoisted_140 = { class: "fs-4 fw-bold" }
const _hoisted_141 = { class: "text-end text-nowrap align-baseline" }
const _hoisted_142 = { class: "d-flex flex-column gap-6" }
const _hoisted_143 = { class: "fs-4 fw-bold" }
const _hoisted_144 = { class: "fs-4 fw-bold" }
const _hoisted_145 = {
  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer",
  "data-bs-target": "#modal_draft_orders_update_shipping_fee",
  "data-bs-toggle": "modal"
}
const _hoisted_146 = { class: "fs-4 fw-bold" }
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { key: 1 }
const _hoisted_149 = { class: "d-flex flex-column gap-5" }
const _hoisted_150 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_151 = { class: "d-flex flex-column gap-5" }
const _hoisted_152 = ["disabled"]
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_154 = { class: "svg-icon svg-icon-3" }
const _hoisted_155 = ["disabled"]
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_157 = { class: "svg-icon svg-icon-3" }
const _hoisted_158 = { class: "d-flex flex-column gap-5" }
const _hoisted_159 = { class: "d-flex flex-wrap justify-content-between gap-2" }
const _hoisted_160 = { class: "me-2" }
const _hoisted_161 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_162 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_163 = ["disabled"]
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_165 = { class: "svg-icon svg-icon-3" }
const _hoisted_166 = ["disabled"]
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_168 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_common_product = _resolveComponent("common-product")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_empty_data = _resolveComponent("empty-data")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_add_product_item_modal = _resolveComponent("add-product-item-modal")!
  const _component_add_sku_modal = _resolveComponent("add-sku-modal")!
  const _component_range_size_change = _resolveComponent("range-size-change")!
  const _component_update_shipping_fee = _resolveComponent("update-shipping-fee")!
  const _component_set_business_date_modal = _resolveComponent("set-business-date-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen017.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.getOwnerLabel(_ctx.getDefaultOwnerId)), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("salesOrderOverview.operatingEntity")), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("salesOrder.customer")), 1),
                  _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.customer_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                        disabled: _ctx.formData.order_number !== '',
                        loading: _ctx.options.companyLoading,
                        placeholder: _ctx.t('common.plsSelect'),
                        class: "w-100",
                        clearable: "",
                        onChange: _ctx.customerChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.company, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "loading", "placeholder", "onChange"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("salesOrderOverview.group")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.group_name ? _ctx.formData.profile.group_name : "--"), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t("salesOrderOverview.email")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.email ? _ctx.formData.profile.email : "--"), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t("salesOrderOverview.mobileNumber")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.mobile_number
                  ? _ctx.formData.profile.mobile_number
                  : "--"), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t("salesOrderOverview.tecrmGuideId")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.tecrm_guide_id
                  ? _ctx.formData.profile.tecrm_guide_id
                  : "--"), 1)
                ]),
                _hoisted_23
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("order.merchant")), 1),
                  _createVNode(_component_el_form_item, { prop: "merchant" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.merchant,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                        loading: _ctx.options.merchantLoading,
                        placeholder: _ctx.t('common.plsSelect'),
                        "remote-method": _ctx.searchMerchantSourceItems,
                        class: "w-100",
                        clearable: "",
                        disabled: "",
                        filterable: "",
                        remote: "",
                        "remote-show-suffix": "",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSalesChannelsData($event, true)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder", "remote-method"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("order.channel")), 1),
                  _createVNode(_component_el_form_item, { prop: "channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.channel,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.channel) = $event)),
                        loading: _ctx.options.channelLoading,
                        placeholder: _ctx.t('common.plsSelect'),
                        class: "w-100",
                        clearable: "",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.t("salesOrder.shippingAddress")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("salesOrder.shippingAddress")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.getShippingAddressDetail ? _ctx.getShippingAddressDetail : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("salesOrder.recipientFirstName")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.firstname
                        ? _ctx.formData.shipping_address.firstname
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("salesOrder.recipientLastName")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.lastname
                        ? _ctx.formData.shipping_address.lastname
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("salesOrder.recipientCompany")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.company
                        ? _ctx.formData.shipping_address.company
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("salesOrder.recipientStreetAddress")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.street
                        ? _ctx.formData.shipping_address.street
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("salesOrder.recipientCity")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.city
                        ? _ctx.formData.shipping_address.city
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("salesOrder.recipientProvince")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.region
                        ? _ctx.formData.shipping_address.region
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("salesOrder.recipientCountry")) + ":", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.value
                        }, [
                          (
                        item.value === _ctx.formData.shipping_address.country_iso_2
                      )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(item.label), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t("salesOrder.recipientPostalCode")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.zip_code
                        ? _ctx.formData.shipping_address.zip_code
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.t("salesOrder.recipientMobileNo")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.telephone
                        ? _ctx.formData.shipping_address.telephone
                        : "--"), 1)
                    ])
                  ])
                ]),
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.t("salesOrder.billingAddress")), 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.t("salesOrder.billingAddress")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.getBillingAddressDetail ? _ctx.getBillingAddressDetail : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.t("salesOrder.billingFirstName")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.firstname
                        ? _ctx.formData.billing_address.firstname
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.t("salesOrder.billingLastName")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.lastname
                        ? _ctx.formData.billing_address.lastname
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.t("salesOrder.billingCompany")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.company
                        ? _ctx.formData.billing_address.company
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.t("salesOrder.billingStreetAddress")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.street
                        ? _ctx.formData.billing_address.street
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.t("salesOrder.billingCity")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.city
                        ? _ctx.formData.billing_address.city
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.t("salesOrder.billingStateProvince")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.region
                        ? _ctx.formData.billing_address.region
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.t("salesOrder.billingCountry")) + ":", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.value
                        }, [
                          (
                        item.value === _ctx.formData.billing_address.country_iso_2
                      )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(item.label), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.t("salesOrder.billingPostalCode")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.zip_code
                        ? _ctx.formData.billing_address.zip_code
                        : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.t("salesOrder.billingContactMobileNo")) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.telephone
                        ? _ctx.formData.billing_address.telephone
                        : "--"), 1)
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("ul", _hoisted_83, [
                _createElementVNode("li", {
                  class: "nav-item",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTab(0)))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{
                  'active text-dark': _ctx.options.doubleSaleProductTabIndex === 0,
                }, "nav-link cursor-pointer ms-0 fw-bolder"])
                  }, _toDisplayString(_ctx.t("draftOrder.publishedItems")) + "（" + _toDisplayString(_ctx.formData.release_qty) + "） ", 3)
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeTab(1)))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{
                  'active text-dark': _ctx.options.doubleSaleProductTabIndex === 1,
                }, "nav-link cursor-pointer ms-0 fw-bolder"])
                  }, _toDisplayString(_ctx.t("draftOrder.deletedItems")) + "（" + _toDisplayString(_ctx.getFilterProductItems(1, 0).length) + "） ", 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_el_select, {
                  class: "w-200px",
                  style: _normalizeStyle({
                '--ghost-label':
                  _ctx.options.doubleSaleProductTabFilterValue === 0
                    ? `'${_ctx.t('common.all')}（${
                        _ctx.getFilterProductItems(
                          _ctx.options.doubleSaleProductTabIndex,
                          0
                        ).length
                      }）'`
                    : `'${_ctx.t('draftOrder.abnormalCases')}（${
                        _ctx.getFilterProductItems(
                          _ctx.options.doubleSaleProductTabIndex,
                          1
                        ).length
                      }）'`,
              }),
                  modelValue: _ctx.options.doubleSaleProductTabFilterValue,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.options.doubleSaleProductTabFilterValue) = $event)),
                  placeholder: _ctx.t('common.plsSelect')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: `${_ctx.t('common.all')}（${
                  _ctx.getFilterProductItems(_ctx.options.doubleSaleProductTabIndex, 0)
                    .length
                }）`,
                      value: 0
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: `${_ctx.t('draftOrder.abnormalCases')}（${
                  _ctx.getFilterProductItems(_ctx.options.doubleSaleProductTabIndex, 1)
                    .length
                }）`,
                      value: 1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["style", "modelValue", "placeholder"]),
                _createElementVNode("button", {
                  disabled: _ctx.loading || _ctx.disabledExportProgress || _ctx.isChangeData,
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportItems && _ctx.exportItems(...args)))
                }, [
                  (_ctx.loading || _ctx.disabledExportProgress)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_86))
                    : (_openBlock(), _createElementBlock("span", _hoisted_87, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr044.svg" })
                      ])),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("draftOrder.exportItems")), 1)
                ], 8, _hoisted_85)
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("table", _hoisted_90, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_91, [
                      _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.t("order.position")), 1),
                      _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.t("order.product")), 1),
                      _createElementVNode("th", _hoisted_94, _toDisplayString(_ctx.t("order.sku")), 1),
                      _createElementVNode("th", _hoisted_95, _toDisplayString(_ctx.$t("draftOrder.hsCode")), 1),
                      _createElementVNode("th", _hoisted_96, _toDisplayString(_ctx.t("order.originalPrice")), 1),
                      _createElementVNode("th", _hoisted_97, _toDisplayString(_ctx.t("orderRequest.qtyConf")), 1),
                      _createElementVNode("th", _hoisted_98, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("order.margin")), 1),
                        (_ctx.formData.customer_id === '')
                          ? (_openBlock(), _createBlock(_component_el_popover, {
                              key: 0,
                              placement: "top",
                              trigger: "hover",
                              width: "auto"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", _hoisted_100, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen045.svg" })
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.$t("draftOrder.plsSelectCustomerTip")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("th", _hoisted_101, _toDisplayString(_ctx.t("order.tax")), 1),
                      _createElementVNode("th", _hoisted_102, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.netPrice")), 1),
                        (_ctx.formData.customer_id === '')
                          ? (_openBlock(), _createBlock(_component_el_popover, {
                              key: 0,
                              placement: "top",
                              trigger: "hover",
                              width: "auto"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", _hoisted_104, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen045.svg" })
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.$t("draftOrder.plsSelectCustomerTip")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("th", _hoisted_105, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.total")), 1),
                        (_ctx.formData.customer_id === '')
                          ? (_openBlock(), _createBlock(_component_el_popover, {
                              key: 0,
                              placement: "top",
                              trigger: "hover",
                              width: "auto"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", _hoisted_107, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen045.svg" })
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t("draftOrder.plsSelectCustomerTip")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.isDisabledDoubleEdit)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_108, _toDisplayString(_ctx.t("common.action")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_109, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.draft_items, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.product_id !== 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (
                        (_ctx.options.doubleSaleProductTabIndex === 0 &&
                          !item.is_deleted) ||
                        (_ctx.options.doubleSaleProductTabIndex === 1 &&
                          item.is_deleted)
                      )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (
                          _ctx.options.doubleSaleProductTabFilterValue === 0 ||
                          (_ctx.options.doubleSaleProductTabFilterValue === 1 &&
                            item.in_blacklist)
                        )
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_110, [
                                          _createElementVNode("td", _hoisted_111, _toDisplayString(item.position), 1),
                                          (_openBlock(), _createBlock(_component_common_product, {
                                            key: index,
                                            brand_article_no: item.brand_article_no,
                                            brand_id: item.brand,
                                            color: item.color_label,
                                            country: item.country_of_origin,
                                            countryShow: true,
                                            ean: item.ean_code,
                                            eanShow: true,
                                            gallery: _ctx.getSkuListItemImages(item),
                                            merchant_article_no: item.merchant_article_no,
                                            name: item.name,
                                            name_en: item.name,
                                            product_identifier_id: '0',
                                            rangeSize: item.range_size,
                                            size: item.size_label,
                                            source_link: ''
                                          }, null, 8, ["brand_article_no", "brand_id", "color", "country", "ean", "gallery", "merchant_article_no", "name", "name_en", "rangeSize", "size"])),
                                          _createElementVNode("td", _hoisted_112, [
                                            _createVNode(_component_el_popover, {
                                              disabled: !item.material,
                                              placement: "top",
                                              trigger: "hover",
                                              width: "auto"
                                            }, {
                                              reference: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_113, [
                                                  _createElementVNode("div", _hoisted_114, [
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass({
                                        'text-danger': item.in_blacklist,
                                      })
                                                    }, _toDisplayString(item.hs_code ? item.hs_code : "--"), 3),
                                                    (item.in_blacklist)
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_115))
                                                      : _createCommentVNode("", true),
                                                    (item.is_new)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_116, "New"))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_117, _toDisplayString(item.material ? item.material : "--"), 1)
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(item.material), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled"])
                                          ]),
                                          _createElementVNode("td", _hoisted_118, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                  item.base_price,
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_119, _toDisplayString(item.qty), 1),
                                          _createElementVNode("td", _hoisted_120, [
                                            (_ctx.formData.customer_id !== '')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.getDoubleMargin(item.discount) + "%"), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_122, "--"))
                                          ]),
                                          _createElementVNode("td", _hoisted_123, _toDisplayString(item.tax_rate + "%"), 1),
                                          _createElementVNode("td", _hoisted_124, [
                                            (_ctx.formData.customer_id !== '')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_ctx.$currency.currency(
                                item.net_price,
                                2,
                                ",",
                                ".",
                                "€ "
                              )), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_126, "--"))
                                          ]),
                                          _createElementVNode("td", _hoisted_127, [
                                            (_ctx.formData.customer_id !== '')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString(_ctx.$currency.currency(
                                item.sales_price * item.qty,
                                2,
                                ",",
                                ".",
                                "€ "
                              )), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_129, "--"))
                                          ]),
                                          (!_ctx.isDisabledDoubleEdit)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_130, [
                                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                                  default: _withCtx(() => [
                                                    (item.is_deleted)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          title: _ctx.$t('common.restore'),
                                                          class: "btn btn-sm btn-icon btn-light",
                                                          type: "button",
                                                          onClick: ($event: any) => (_ctx.removeDoubleItem(item))
                                                        }, [
                                                          _createElementVNode("span", _hoisted_132, [
                                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                                                          ])
                                                        ], 8, _hoisted_131))
                                                      : (_openBlock(), _createElementBlock("button", {
                                                          key: 1,
                                                          disabled: 
                                  _ctx.getDoubleProductNotDeletedItems.length === 1
                                ,
                                                          title: _ctx.$t('common.delete'),
                                                          class: "btn btn-sm btn-icon btn-light-danger",
                                                          type: "button",
                                                          onClick: ($event: any) => (_ctx.removeDoubleItem(item))
                                                        }, [
                                                          _createElementVNode("span", _hoisted_134, [
                                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                                                          ])
                                                        ], 8, _hoisted_133))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    _withDirectives(_createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: !_ctx.isDisabledDoubleEdit ? 11 : 10
                      }, [
                        _createVNode(_component_empty_data)
                      ], 8, _hoisted_135)
                    ], 512), [
                      [_vShow, _ctx.isProductEmpty]
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: !_ctx.isDisabledDoubleEdit ? 10 : 9,
                        class: "text-end align-baseline"
                      }, [
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.t("orderRequest.totalOriginalAmount")) + ": ", 1),
                          _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.t("orderRequest.shippingChargeInclTax")) + ": ", 1),
                          _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.t("orderRequest.total")) + ": ", 1)
                        ])
                      ], 8, _hoisted_136),
                      _createElementVNode("td", _hoisted_141, [
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("div", _hoisted_143, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                            _ctx.totalOriginalAmount,
                            2,
                            ",",
                            ".",
                            "€ "
                          )), 1)
                          ]),
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                            _ctx.formData.base_shipping_amount,
                            2,
                            ",",
                            ".",
                            "€ "
                          )), 1),
                            _createElementVNode("span", _hoisted_145, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_146, [
                            (_ctx.formData.customer_id !== '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_147, _toDisplayString(_ctx.$currency.currency(_ctx.getVatTotal, 2, ",", ".", "€ ")), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_148, _toDisplayString(_ctx.$currency.currency(0, 2, ",", ".", "€ ")), 1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createVNode(_component_window_resize, null, {
            sm: _withCtx(() => [
              _createElementVNode("div", _hoisted_149, [
                _createElementVNode("button", {
                  class: "btn bg-secondary text-gray-600 w-100",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                }, [
                  _createElementVNode("span", _hoisted_150, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.back")), 1)
                ]),
                _createElementVNode("div", _hoisted_151, [
                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                    default: _withCtx(() => [
                      (!_ctx.isDisabledDoubleEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.loading || _ctx.isDisabledSubmit,
                            class: "btn btn-primary w-100",
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                          }, [
                            _withDirectives(_createElementVNode("span", null, [
                              _hoisted_153,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                            ], 512), [
                              [_vShow, _ctx.loading]
                            ]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_154, [
                                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
                            ], 512), [
                              [_vShow, !_ctx.loading]
                            ])
                          ], 8, _hoisted_152))
                        : _createCommentVNode("", true),
                      (!_ctx.isDisabledDoubleEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            disabled: 
                    _ctx.loading ||
                    _ctx.isChangeData ||
                    _ctx.formData.can_generate_order === 0 ||
                    _ctx.formData.order_number !== ''
                  ,
                            class: "btn btn-primary w-100",
                            type: "button",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.createDraftOrderGenerateOrder && _ctx.createDraftOrderGenerateOrder(...args)))
                          }, [
                            _withDirectives(_createElementVNode("span", null, [
                              _hoisted_156,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                            ], 512), [
                              [_vShow, _ctx.loading]
                            ]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_157, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrderOverview.generateOrder")), 1)
                            ], 512), [
                              [_vShow, !_ctx.loading]
                            ])
                          ], 8, _hoisted_155))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            lg: _withCtx(() => [
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("button", {
                      class: "btn bg-secondary text-gray-600",
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_161, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.back")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_162, [
                    _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                      default: _withCtx(() => [
                        (!_ctx.isDisabledDoubleEdit)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              disabled: _ctx.loading || _ctx.isDisabledSubmit,
                              class: "btn btn-primary",
                              type: "button",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, [
                                _hoisted_164,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ], 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_165, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_163))
                          : _createCommentVNode("", true),
                        (!_ctx.isDisabledDoubleEdit)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              disabled: 
                      _ctx.loading ||
                      _ctx.isChangeData ||
                      _ctx.formData.can_generate_order === 0 ||
                      _ctx.formData.order_number !== ''
                    ,
                              class: "btn btn-primary",
                              type: "button",
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.createDraftOrderGenerateOrder && _ctx.createDraftOrderGenerateOrder(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, [
                                _hoisted_167,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ], 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_168, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrderOverview.generateOrder")), 1)
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_166))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_add_product_item_modal, {
      form: _ctx.formData,
      onUpdateList: _ctx.updateProductItem
    }, null, 8, ["form", "onUpdateList"]),
    _createVNode(_component_add_sku_modal, {
      form: _ctx.formData,
      onUpdateList: _ctx.updateProductItem
    }, null, 8, ["form", "onUpdateList"]),
    _createVNode(_component_range_size_change, {
      ref: "rangeSizeChangeModalRef",
      onUpdateList: _ctx.rangeSizeChange
    }, null, 8, ["onUpdateList"]),
    _createVNode(_component_update_shipping_fee, {
      amount: _ctx.formData.base_shipping_amount,
      onUpdateList: _ctx.updateShippingFee
    }, null, 8, ["amount", "onUpdateList"]),
    _createVNode(_component_set_business_date_modal, {
      ref: "setBusinessDateModalRef",
      "last-billing-date": _ctx.formData.last_billing_date,
      onModalSubmit: _ctx.setBusinessDate
    }, null, 8, ["last-billing-date", "onModalSubmit"])
  ], 64))
}